import React, { FC } from 'react';

import { CreditCardShape } from 'components/payments/CreditCardShape';
import { PayPal } from 'components/icons/PayPal';

import { PaymentItem } from './PaymentItem';

const paypalId = 'paypal';

type Props = {
  selectedId?: string;
  url: string;
  onSelected: (id: typeof paypalId) => void;
};

export const PaymentItemPayPal: FC<Props> = ({ selectedId, url, onSelected }) => {
  return (
    <PaymentItem id={paypalId} selectedId={selectedId}>
      <CreditCardShape>
        <a
          onClick={() => onSelected(paypalId)}
          href={url}
          className='btn btn--paypal d-flex align-items-center h-100'
        >
          <PayPal width={120} className='ml-mini' />
        </a>
      </CreditCardShape>
    </PaymentItem>
  );
};
